import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const scrollToForm = () => {
  const el = document.getElementById("apply");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-white/5 bg-black/60 backdrop-blur-2xl backdrop-saturate-150"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-12">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-2.5"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-[#D4AF37] font-bold text-black">
            C
          </span>
          <span className="hidden text-sm font-semibold tracking-wide text-white sm:inline">
            CAPITAL ACCESS <span className="text-[#D4AF37]">HUB</span>
          </span>
        </Link>
        <Button
          data-testid="header-cta-button"
          onClick={scrollToForm}
          className="rounded-lg bg-[#D4AF37] px-5 py-2 text-sm font-bold text-black hover:bg-[#F0C94F] hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] transition-all"
        >
          Check My Options
        </Button>
      </div>
    </header>
  );
};
